/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CourierUserCreateWhatsAppUserRequest,
  InvoiceInvoiceIdRequest,
  MailBank,
  MailBankBulkSendInvoicesRequest,
  MailBankSendConfirmationReferralRequest,
  MailBankSendManifestRequestEmailRequest,
  MailBankSendNotificationRequest,
  MailBankSendPackageStatusAlertRequest,
  MailBankSendPasswordResetEmailRequest,
  MailBankSendWelcomeEmailRequest,
  MailBankVerifyUserRequest,
  RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest,
} from '../models/index';
import {
    CourierUserCreateWhatsAppUserRequestFromJSON,
    CourierUserCreateWhatsAppUserRequestToJSON,
    InvoiceInvoiceIdRequestFromJSON,
    InvoiceInvoiceIdRequestToJSON,
    MailBankFromJSON,
    MailBankToJSON,
    MailBankBulkSendInvoicesRequestFromJSON,
    MailBankBulkSendInvoicesRequestToJSON,
    MailBankSendConfirmationReferralRequestFromJSON,
    MailBankSendConfirmationReferralRequestToJSON,
    MailBankSendManifestRequestEmailRequestFromJSON,
    MailBankSendManifestRequestEmailRequestToJSON,
    MailBankSendNotificationRequestFromJSON,
    MailBankSendNotificationRequestToJSON,
    MailBankSendPackageStatusAlertRequestFromJSON,
    MailBankSendPackageStatusAlertRequestToJSON,
    MailBankSendPasswordResetEmailRequestFromJSON,
    MailBankSendPasswordResetEmailRequestToJSON,
    MailBankSendWelcomeEmailRequestFromJSON,
    MailBankSendWelcomeEmailRequestToJSON,
    MailBankVerifyUserRequestFromJSON,
    MailBankVerifyUserRequestToJSON,
    RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequestFromJSON,
    RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequestToJSON,
} from '../models/index';

export interface MailBankBulkSendInvoicesOperationRequest {
    mailBankBulkSendInvoicesRequest?: MailBankBulkSendInvoicesRequest;
}

export interface MailBankBulkSendInvoicesV2Request {
    request: {
        selected: number[];
        notificationTypes: string[];
    }
}

export interface MailBankRequestCallbackRequest {
    realm: string;
    phoneNumber: string;
    name: string;
}

export interface MailBankSendConfirmationReferralOperationRequest {
    mailBankSendConfirmationReferralRequest?: MailBankSendConfirmationReferralRequest;
}

export interface MailBankSendInvoiceRequest {
    invoiceInvoiceIdRequest: InvoiceInvoiceIdRequest;
    notificationTypes: string[];
}

/**
 * A reference to a file already uploaded to /api/Uploads/comm-{courierId}/upload.
 *
 * The client sends a REFERENCE, never bytes and never a URL — the server reads
 * the object itself out of R2. `container` MUST be `comm-${courierId}` for the
 * sending courier; the API rejects anything else, because sendMailV2 has no
 * session and an arbitrary container would let a caller exfiltrate another
 * tenant's files.
 *
 * `size` and `contentType` are advisory — the server re-derives both from the
 * stored object and enforces its caps on the real bytes.
 */
export interface MailAttachmentRef {
    container: string;
    filename: string;
    name?: string;
    size?: number;
    contentType?: string;
}

/**
 * Body of POST /MailBanks/sendMailV2.
 *
 * `to` is intentionally `string | string[]`: most callers pass an array, but
 * several internal models and the public marketing contact form pass a bare
 * string, and the API normalizes both.
 */
export interface SendMailV2Body {
    type: 'All' | 'Individual';
    notificationType: 'email' | 'whatsapp';
    to?: string | string[];
    subject: string;
    html: string;
    realm: string;
    idempotencyKey?: string;
    attachments?: MailAttachmentRef[];
    /**
     * Opt in to real attachments on a broadcast. Broadcasts default to link
     * mode because the bulk path BCCs in batches of 9 — attached bytes are
     * multiplied by the batch count. Subject to a much lower size cap.
     */
    allowBroadcastAttach?: boolean;
}

export interface MailBankSendMailV2Request {
    mailObject?: SendMailV2Body;
}

/** Body of POST /MailBanks/previewCommunication. */
export interface PreviewCommunicationBody {
    realm: string;
    html: string;
    type?: 'All' | 'Individual';
    attachments?: MailAttachmentRef[];
}

/**
 * Rendered preview. `html` is the complete email — body wrapped in the same
 * courier-branded template the send path uses, so it cannot drift.
 */
export interface PreviewCommunicationResult {
    html: string;
    /** True when sanitization changed the body (something was stripped). */
    sanitized: boolean;
    hadDataUriImage: boolean;
    attachmentMode: 'attach' | 'link';
}

export interface MailBankPreviewCommunicationRequest {
    request: PreviewCommunicationBody;
}

export interface SendToCourierOwnersBody {
    courierIds?: number[];
    all?: boolean;
    notificationType: 'email' | 'whatsapp';
    subject: string;
    html: string;
    idempotencyKey?: string;
}

/** @deprecated Use MailAttachmentRef — kept so older imports keep resolving. */
export type CommunicationAttachment = MailAttachmentRef;

export interface MailBankSendToCourierOwnersRequest {
    request: SendToCourierOwnersBody;
}

export interface MailBankSendManifestRequestEmailOperationRequest {
    mailBankSendManifestRequestEmailRequest?: MailBankSendManifestRequestEmailRequest;
}

export interface MailBankSendNotificationOperationRequest {
    mailBankSendNotificationRequest: MailBankSendNotificationRequest;
}

export interface MailBankSendPackageStatusAlertOperationRequest {
    mailBankSendPackageStatusAlertRequest?: MailBankSendPackageStatusAlertRequest;
}

export interface MailBankSendPasswordResetEmailOperationRequest {
    mailBankSendPasswordResetEmailRequest?: MailBankSendPasswordResetEmailRequest;
}

export interface MailBankSendPasswordSetEmailRequest {
    roleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest?: RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest;
}

export interface MailBankSendWelcomeEmailOperationRequest {
    mailBankSendWelcomeEmailRequest?: MailBankSendWelcomeEmailRequest;
}

export interface MailBankVerifyUserOperationRequest {
    mailBankVerifyUserRequest?: MailBankVerifyUserRequest;
}

export interface SendWelcomeEmailRequest {
    courierId: string;
    userId: string;
}

export interface SendOtpRequest {
    userId: string;
    method: string;
    newContact?: string;
}

export interface SendInvoiceUploadedAlertRequest {
    packageId: string;
}

/**
 * 
 */
export class MailBankApi extends runtime.BaseAPI {

    /**
     */
    async mailBankBulkSendInvoicesRaw(requestParameters: MailBankBulkSendInvoicesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/MailBanks/bulkSendInvoices`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MailBankBulkSendInvoicesRequestToJSON(requestParameters['mailBankBulkSendInvoicesRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async mailBankBulkSendInvoices(requestParameters: MailBankBulkSendInvoicesOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.mailBankBulkSendInvoicesRaw(requestParameters, initOverrides);
    }

    /**
     */
    async mailBankBulkSendInvoicesV2Raw(requestParameters: MailBankBulkSendInvoicesV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'data',
                'Required parameter "data" was null or undefined when calling mailBankBulkSendInvoicesV2().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/MailBanks/bulkSendInvoicesV2`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['request']
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async mailBankBulkSendInvoicesV2(requestParameters: MailBankBulkSendInvoicesV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.mailBankBulkSendInvoicesV2Raw(requestParameters, initOverrides);
    }

    /**
     */
    async mailBankRequestCallbackRaw(requestParameters: MailBankRequestCallbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/MailBanks/requestCallback`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: {
                parameters: {
                    realm: requestParameters.realm,
                    phoneNumber: requestParameters.phoneNumber,
                    name: requestParameters.name
                }
            },
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async mailBankRequestCallback(requestParameters: MailBankRequestCallbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.mailBankRequestCallbackRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async mailBankSendConfirmationReferralRaw(requestParameters: MailBankSendConfirmationReferralOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/MailBanks/sendConfirmationReferral`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MailBankSendConfirmationReferralRequestToJSON(requestParameters['mailBankSendConfirmationReferralRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async mailBankSendConfirmationReferral(requestParameters: MailBankSendConfirmationReferralOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.mailBankSendConfirmationReferralRaw(requestParameters, initOverrides);
    }

    /**
     */
    async mailBankSendInvoiceRaw(requestParameters: MailBankSendInvoiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters['invoiceInvoiceIdRequest'] == null) {
            throw new runtime.RequiredError(
                'invoiceInvoiceIdRequest',
                'Required parameter "invoiceInvoiceIdRequest" was null or undefined when calling mailBankSendInvoice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/MailBanks/sendInvoice`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InvoiceInvoiceIdRequestToJSON(requestParameters['invoiceInvoiceIdRequest']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async mailBankSendInvoice(requestParameters: MailBankSendInvoiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.mailBankSendInvoiceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async mailBankSendMailV2Raw(requestParameters: MailBankSendMailV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/MailBanks/sendMailV2`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['mailObject'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async mailBankSendMailV2(requestParameters: MailBankSendMailV2Request = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.mailBankSendMailV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Render a communication exactly as it will be delivered, without sending.
     *
     * Calls the same server-side renderer the send path uses, so the preview
     * cannot drift from the real email.
     */
    async mailBankPreviewCommunicationRaw(requestParameters: MailBankPreviewCommunicationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PreviewCommunicationResult>> {
        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling mailBankPreviewCommunication().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/MailBanks/previewCommunication`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['request'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async mailBankPreviewCommunication(requestParameters: MailBankPreviewCommunicationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PreviewCommunicationResult> {
        const response = await this.mailBankPreviewCommunicationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async mailBankSendToCourierOwnersRaw(requestParameters: MailBankSendToCourierOwnersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling mailBankSendToCourierOwners().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/MailBanks/sendToCourierOwners`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['request'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async mailBankSendToCourierOwners(requestParameters: MailBankSendToCourierOwnersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.mailBankSendToCourierOwnersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async mailBankSendManifestRequestEmailRaw(requestParameters: MailBankSendManifestRequestEmailOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<object>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/MailBanks/sendManifestRequestEmail`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MailBankSendManifestRequestEmailRequestToJSON(requestParameters['mailBankSendManifestRequestEmailRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async mailBankSendManifestRequestEmail(requestParameters: MailBankSendManifestRequestEmailOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<object>> {
        const response = await this.mailBankSendManifestRequestEmailRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async mailBankSendNotificationRaw(requestParameters: MailBankSendNotificationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['mailBankSendNotificationRequest'] == null) {
            throw new runtime.RequiredError(
                'mailBankSendNotificationRequest',
                'Required parameter "mailBankSendNotificationRequest" was null or undefined when calling mailBankSendNotification().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/MailBanks/sendNotification`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MailBankSendNotificationRequestToJSON(requestParameters['mailBankSendNotificationRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async mailBankSendNotification(requestParameters: MailBankSendNotificationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.mailBankSendNotificationRaw(requestParameters, initOverrides);
    }

    /**
     */
    async mailBankSendPackageStatusAlertRaw(requestParameters: MailBankSendPackageStatusAlertOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/MailBanks/sendPackageStatusAlert`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MailBankSendPackageStatusAlertRequestToJSON(requestParameters['mailBankSendPackageStatusAlertRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async mailBankSendPackageStatusAlert(requestParameters: MailBankSendPackageStatusAlertOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.mailBankSendPackageStatusAlertRaw(requestParameters, initOverrides);
    }

    /**
     */
    async mailBankSendPasswordResetEmailRaw(requestParameters: MailBankSendPasswordResetEmailOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/MailBanks/sendPasswordResetEmail`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MailBankSendPasswordResetEmailRequestToJSON(requestParameters['mailBankSendPasswordResetEmailRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async mailBankSendPasswordResetEmail(requestParameters: MailBankSendPasswordResetEmailOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.mailBankSendPasswordResetEmailRaw(requestParameters, initOverrides);
    }

    /**
     */
    async mailBankSendPasswordSetEmailRaw(requestParameters: MailBankSendPasswordSetEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/MailBanks/sendPasswordSetEmail`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequestToJSON(requestParameters['roleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async mailBankSendPasswordSetEmail(requestParameters: MailBankSendPasswordSetEmailRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.mailBankSendPasswordSetEmailRaw(requestParameters, initOverrides);
    }

    /**
     */
    async mailBankSendWelcomeEmailRaw(requestParameters: MailBankSendWelcomeEmailOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/MailBanks/sendWelcomeEmail`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MailBankSendWelcomeEmailRequestToJSON(requestParameters['mailBankSendWelcomeEmailRequest']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async mailBankSendWelcomeEmail(requestParameters: MailBankSendWelcomeEmailOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.mailBankSendWelcomeEmailRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async mailBankVerifyUserRaw(requestParameters: MailBankVerifyUserOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/MailBanks/verifyUser`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MailBankVerifyUserRequestToJSON(requestParameters['mailBankVerifyUserRequest']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async mailBankVerifyUser(requestParameters: MailBankVerifyUserOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.mailBankVerifyUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    async sendWelcomeEmailRaw(requestParameters: SendWelcomeEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.courierId === null || requestParameters.courierId === undefined) {
            throw new runtime.RequiredError('courierId', 'Required parameter "courierId" was null or undefined when calling sendWelcomeEmail.');
        }
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId', 'Required parameter "userId" was null or undefined when calling sendWelcomeEmail.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/MailBanks/sendWelcomeEmail`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: {
                courierId: requestParameters.courierId,
                userId: requestParameters.userId
            },
        }, initOverrides);

        if (response.ok) {
            return new runtime.VoidApiResponse(response);
        }

        throw new Error('Error sending welcome email');
    }

    async sendWelcomeEmail(requestParameters: SendWelcomeEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.sendWelcomeEmailRaw(requestParameters, initOverrides);
    }

    async sendOtpRaw(requestParameters: SendOtpRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/MailBanks/request-verification-code`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: {
                userId: requestParameters.userId,
                method: requestParameters.method,
                newContact: requestParameters.newContact
            },
        }, initOverrides);

        return new runtime.JSONApiResponse<boolean>(response);
    }

    async sendOtp(requestParameters: SendOtpRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.sendOtpRaw(requestParameters, initOverrides);
        return await response.value();
    }

    async sendInvoiceUploadedAlertRaw(requestParameters: SendInvoiceUploadedAlertRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.packageId === null || requestParameters.packageId === undefined) {
            throw new runtime.RequiredError('packageId', 'Required parameter "packageId" was null or undefined when calling sendInvoiceUploadedAlert.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/MailBanks/sendInvoiceUploadedAlert`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: {
                packageId: requestParameters.packageId
            },
        }, initOverrides);

        if (response.ok) {
            return new runtime.VoidApiResponse(response);
        }

        throw new Error('Error sending invoice uploaded alert');
    }

    async sendInvoiceUploadedAlert(requestParameters: SendInvoiceUploadedAlertRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.sendInvoiceUploadedAlertRaw(requestParameters, initOverrides);
    }

}
